module.exports = __webpack_public_path__ + "images/sgp/alt-content-images/alt-content-image-optimized.webp";